// extracted by mini-css-extract-plugin
module.exports = {"comp":"BannerA_comp__GlqnA","banner":"BannerA_banner__PLO2A"};